export default async function ({ app, store }) {
  try {
    let invalidateCache = false
    const TEN_MINUTES = 60 * 10
    const currentTimestamp = Math.floor(Date.now() / 1000)
    const storedTimestamp = await store.getters[
      'common/getLocationMetaTimestamp'
    ]

    if (storedTimestamp) {
      const diff = currentTimestamp - storedTimestamp
      if (diff >= 60 * 10) {
        invalidateCache = true
      }
    }

    if (!invalidateCache && process.client) return

    // const missingMetafields = []
    const metafieldKeys = [
      'breadcrumbs',
      'model_groups',
      'care_instructions',
      'features',
      'feature_list_pdp',
      'colour_code_label',
      'benefits',
    ]

    // BYPASS REDIS
    const { data } = await app.$axios.post(
      '/api/shopify/getLocationMetafields',
      {
        locationId: process.env.SHOPIFY_WEB_LOCATION_ID_CA,
      }
    )

    metafieldKeys.forEach((metafield) => {
      const value = data?.location?.metafields?.nodes.find(
        ({ key }) => key === metafield
      )?.value
      if (value) {
        store.commit('common/setLocationMetafield', {
          key: metafield,
          data: JSON.parse(value),
        })
        app.$redisClient.set(metafield, value, TEN_MINUTES)
      }
    })

    // GET KEYS FROM REDIS
    // for (const key of metafieldKeys) {
    //   const data = await app.$redisClient.get(key)
    //   if (data) {
    //     store.commit('common/setLocationMetafield', {
    //       key,
    //       data: JSON.parse(data),
    //     })
    //   } else {
    //     missingMetafields.push(key)
    //   }
    // }

    // IF KEYS ARE MISSING, GET FROM SHOPIFY
    // if (missingMetafields.length > 0) {
    //   const { data } = await app.$axios.post(
    //     '/api/shopify/getLocationMetafields',
    //     {
    //       locationId: process.env.SHOPIFY_WEB_LOCATION_ID_CA,
    //     }
    //   )

    //   missingMetafields.forEach((metafield) => {
    //     const value = data?.location?.metafields?.nodes.find(
    //       ({ key }) => key === metafield
    //     )?.value
    //     if (value) {
    //       store.commit('common/setLocationMetafield', {
    //         key: metafield,
    //         data: JSON.parse(value),
    //       })
    //       app.$redisClient.set(metafield, value, TEN_MINUTES)
    //     }
    //   })
    // }

    store.commit('common/setLocationMetaTimestamp', currentTimestamp)
  } catch (e) {
    app.$sentryException(e, {
      source: 'default layout',
      level: 'warning',
      extra: 'Failed to retrieve location metafields',
    })
  }
}
